import { render, staticRenderFns } from "./NotificationItem.vue?vue&type=template&id=3f49e1e0&scoped=true"
import script from "./NotificationItem.vue?vue&type=script&lang=ts"
export * from "./NotificationItem.vue?vue&type=script&lang=ts"
import style0 from "./NotificationItem.vue?vue&type=style&index=0&id=3f49e1e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f49e1e0",
  null
  
)

export default component.exports